var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandGlovBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    id: "Path_1",
    className: "st0",
    d: "M13.4,29.3c-0.1-0.2-0.2-0.4-0.2-0.7c-1.1-3-2-5.8-5.2-6.7c-1-0.3-2.1-0.3-3.1,0l0.3,0.9 c0.3,0.9,0.8,1.7,1.3,2.4l3.9,5.1L13.4,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "st0",
    d: "M8.3,20.8c3.8,1,5,4.4,6.1,7.5c0.1,0.2,0.2,0.4,0.2,0.6l6.4-2.3l-1-2.7c0-0.1,0-0.2,0-0.2 c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1l4-8.7c0.4-0.9,0-2-0.9-2.5c-0.9-0.4-2,0-2.5,0.9L19.4,16c-0.2,0.5-0.7,0.7-1.2,0.7 c-0.5,0-0.9-0.3-1.1-0.8L12.3,2.8c-0.2-0.6-0.9-1-1.6-0.7c0,0-0.1,0-0.1,0c-0.6,0.3-0.9,1-0.6,1.6l2.4,6.7l0.7,1.9 c0,0.1,0,0.2,0,0.2c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.5-0.2-0.6-0.4l-4-11C7.9,1.5,7.7,1.3,7.4,1.1C7.1,1,6.8,1,6.4,1.1 C5.8,1.3,5.5,2,5.7,2.6l4,10.9c0.1,0.3,0,0.7-0.4,0.8c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0h0c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0 c0,0,0,0-0.1,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c-0.1-0.1-0.1-0.1-0.1-0.2L5.4,5.3c-0.2-0.6-0.9-1-1.6-0.7c-0.6,0.2-1,0.9-0.7,1.6 l1.5,4.1l2.3,6.4c0.1,0.3,0,0.7-0.4,0.8c-0.1,0-0.1,0-0.2,0h0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c0,0-0.1-0.1-0.1-0.1 c0,0,0,0,0,0c-0.1-0.1-0.1-0.1-0.1-0.2l-2.3-6.4c-0.2-0.6-0.9-1-1.6-0.7c0,0-0.1,0-0.1,0c-0.6,0.3-0.9,1-0.6,1.6l3.4,9.2 C5.7,20.4,7,20.4,8.3,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st0",
    d: "M19.6,12.6c0.1-0.1,0.1-0.2,0.2-0.3V4.7c0-0.7-0.6-1.2-1.3-1.2c-0.7,0-1.2,0.6-1.2,1.2v8l1,2.8 L19.6,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "st0",
    d: "M23.5,11.1V2.3C23.5,1.6,23,1,22.3,1S21,1.6,21,2.3v8.9C21.8,10.8,22.7,10.7,23.5,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    className: "st0",
    d: "M27.9,31.6H25c-0.2,0.5-0.6,0.9-1.1,1.1l-0.3,0.1H26c0.7,0,1.3,0.6,1.3,1.2v0.6 c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6v-0.6h-5.9L14.9,36h13c0.3,0,0.6-0.3,0.6-0.6v-3.1C28.5,31.9,28.3,31.6,27.9,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    className: "st0",
    d: "M34.3,17.5L34.3,17.5c-0.7-0.7-1.9-0.7-2.7,0l-2.3,2.3c-0.5,0.5-1.3,0.5-1.8,0 c-0.2-0.2-0.4-0.6-0.4-0.9V4.7c0-0.7-0.6-1.2-1.2-1.2c0,0-0.1,0-0.1,0c-0.7,0.1-1.2,0.7-1.2,1.3V12c0.8,0.9,0.9,2.2,0.4,3.3 l-3.9,8.4l0.9,2.6c0.8,0,1.5,0.5,1.8,1.2l1,2.9c0,0,0,0,0,0h2.3v-3.1c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.2,0.1-0.2v0l6.9-6.7 C35.1,19.4,35.1,18.2,34.3,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    className: "st0",
    d: "M23.8,31.3c0.1-0.2,0.1-0.3,0-0.5l-1-2.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.1,0-0.1,0-0.2,0l-11.6,4.2 L9.8,32l1.5,4l12.2-4.4C23.6,31.5,23.7,31.4,23.8,31.3z M22.1,31.4L22.1,31.4c-0.3,0.1-0.7,0-0.8-0.4c0,0,0,0,0,0l-0.2-0.6 l-8.7,3.2c-0.3,0.1-0.7,0-0.8-0.4c-0.1-0.3,0-0.7,0.4-0.8l8.7-3.2c0.6-0.2,1.4,0.1,1.6,0.7l0.2,0.6C22.6,30.9,22.4,31.3,22.1,31.4 L22.1,31.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandGlovBlu);
export default __webpack_public_path__ + "static/media/hand-glov-blu.e90d2194.svg";
export { ForwardRef as ReactComponent };